<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent">First and foremost, I must acknowledge my family, who offered me unlimited support. They include my lovely and talented mom, Marie, and my good-natured old dad, Lenus Johanneck, along with my siblings, Philip, Steve, Kevin, Bob, Jeff, Annie (Hammerschmidt), Pete and Danny, and their wonderful families. Along with them, I have received the support of my friends Cindy Bernardy Lavin and her husband, Bill, from Granite Falls, Minnesota. A special thank-you to my dear friend Monica Fischer for letting me use her story in the “Women and Crime” chapter.</p>
<p class="indent">My boss, Sarah Thapa, and our employer, Park Nicollet Methodist Hospital, once again agreed to make time for me to complete my book, and I am grateful for the consideration. I had the support of my co-workers, Kathy Lambert, Paul Lesnieswski, Shirley Sanon, Katie Nielson, Jenny Rux, Mark Skalsky, Annie Scott and Cassie Wold, who good-naturedly pitched in when extra help was needed.</p>
<p class="indent">My thanks go out to the management of the following businesses: the 5-8 Club, Foshay Tower (W Hotel Minneapolis), St. Paul Hotel, Phil’s Tara Hideaway, Breezy Point Lodge and Bootlegger’s Supper Club.</p>
<p class="indent">I am extremely grateful to Mark Evans for filling in the blanks of his grandfather’s story and for agreeing to co-write his grandfather’s chapter with me. Thank you to Gary Revier of Redwood Falls for providing photos and document images for my chapter about the Redwood Falls bank heist.</p>
<p class="indent">I am grateful to Melanie Dunlap and Penny Anderson for joining me on my adventures. And last but not least, I thank my children, Geoff and Kasey, and their significant others, Adriane (who provided the information about the liquor raid in New Ulm) and Shawn Johnson. I am grateful for grandsons Jojo and Jayvyn, to whom I have the opportunity to leave this modest legacy of my version of Minnesota history. Take what you like and leave the rest.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?4a397ede